<div 
    [ngClass]="{'right-rail-expander-text-child--active': isActive}"
    class="right-rail-expander-text-child"
>
    {{ text }}
</div>
